import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-custom-voice-record',
    template: `
  @if (to.label) {
    <label>{{ to.label }}@if (to.required) {
      <span>*</span>
    }</label>
  }
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormlyFieldCustomVoiceRecord extends FieldType<FieldTypeConfig> {
  get type() {
    return this.to.type || 'text';
  }
}